class PeopleSearch {
    constructor() {
        this.textsearch = document.querySelector('.people__filter--search input');
        this.rolesearch = document.querySelector('.people__filter--role select');
        this.expertisesearch = document.querySelector('.people__filter--expertise select');
        this.people_list = document.querySelector('.people__list');
        this.viewAllLink = document.querySelector('.people__list--link');

        this.ajaxurl = '/search';
        this.data = {
            text: null,
            roleid: null,
            expertiseid: null,
        }

        this.init();
    }

    init() {
        this.bindSearchEvents();
        this.bindHistoryTraversalEvent();
    }

    /**
     * Binds search events to corresponding input elements and executes search.
     *
     * @function bindSearchEvents
     * @description This method binds the 'keyup' event to the textsearch element,
     * the 'change' event to the rolesearch element, and the 'change' event to the
     * expertisesearch element. When any of these events are triggered, the
     * executeSearch method is called with the current context ('this') bound.
     */
    bindSearchEvents() {
        this.textsearch.addEventListener('keyup', this.executeSearch.bind(this));
        this.rolesearch.addEventListener('change', this.executeSearch.bind(this));
        this.expertisesearch.addEventListener('change', this.executeSearch.bind(this));
    }

    /**
     * Binds an event listener to handle history traversal events.
     * When a page is restored from cache or navigated using the history,
     * it will reload the page to ensure it is up-to-date.
     * Phase 2: load filtered search, for now reset all filters
     */
    bindHistoryTraversalEvent() {
        window.addEventListener("pageshow", (event) => {
            if (event.persisted || (typeof window.performance !== "undefined" && window.performance.navigation.type === 2)) {
            // Handle page restore.
            window.location.reload();
        }});
    }

    executeSearch() {
        this.data.text = this.textsearch.value;
        this.data.roleid = this.rolesearch.value;
        this.data.expertiseid = this.expertisesearch.value;

        this.ajaxSearch();
    }

    /**
     * Sends an AJAX request to search for people.
     */
    ajaxSearch() {
        const url = `${this.ajaxurl}/people_search`;

        fetch(url,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-requested-with': 'XMLHttpRequest'
                },
                method: 'POST',
                body: JSON.stringify(this.data),
            })
        .then(response => response.json())
        .then(data => {
            this.viewAllLink.style.visibility ='hidden';
            this.people_list.innerHTML = this.buildPeopleList(data);
        })
    }

    buildPersonCard({ Link, Image, Name, Role, Office }) {
        return `<div class="person-card bg-hover-fg">
                    <a class="person-card__link" href="${Link}">
                        <div class="person-card__photo">
                            <img src="${Image}" alt="${Name}">
                        </div>
                        <h3 class="serif">${Name}</h3>
                        <h4>${Role} - ${Office}</h4>
                    </a>
                </div>`;
    }

    buildPeopleList(peopleData) {
        return peopleData.map(this.buildPersonCard).join('');
    }
}

export default PeopleSearch;
